import React from 'react'
import { FormControlLabel, Checkbox } from '@material-ui/core/'
import checkedIcon from '../../../assetss/img/checkedIcon.svg'
import checked from '../../../assetss/img/checked.svg'

const CheckboxCustom = ({ customClass, text, onChange, value }) => {
  return (
    <FormControlLabel
      className={customClass}
      control={<Checkbox onChange={onChange} value={value} style={{ width: '24px' }} checkedIcon={<img src={checked} alt='checkedIcon' />} color='primary' icon={<img src={checkedIcon} alt='checkedIcon' />} name='checked' />}
      label={text}
    />
  )
}

export default CheckboxCustom
